const giftCardIndex = (state = null, action) => {
    switch(action.type) {
        case 'giftCardIndex':
            return action.payload;
        default:
            return state;
    }
}

export default giftCardIndex;